import React, { useState, useEffect } from "react";

import Loading from "../../../../Components/Interactive/Loading";
// Component Imports
import EditModal from "../../../../Components/EditModal";
// MUI Imports
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";

import CustomerReportDownloadsTable from "./CustomerReportDownloads/CustomerReportDownloadsTable";

const CustomerReportDownloadsWidget = ({ allCustomerData, setTrigger, userId, loading, setCustomerData, setUpdatedData }) => {
  const {
    userReportDownloads: { reportDownloads },
    userDetailsInfo: { customerId },
  } = allCustomerData;

  const { id, peopleReportThreshold, propertyReportThreshold, phoneReportThreshold, socialReportThreshold, autoReportThreshold } = reportDownloads;

  const [open, setIsOpen] = useState(false);
  const [toggleDropdown, setToggleDropdown] = useState(false);
  const [modalIsOpen, setModalOpen] = useState(false);
  const [newPeopleThreshold, setPeopleThreshold] = useState("");
  const [newPropertyThreshold, setPropertyThreshold] = useState("");
  const [newPhoneThreshold, setPhoneThreshold] = useState("");
  const [newSocialThreshold, setSocialThreshold] = useState("");
  const [newAutoThreshold, setAutoThreshold] = useState("");

    // Get customers current data
    useEffect(() => {
      setPeopleThreshold(peopleReportThreshold);
      setPropertyThreshold(propertyReportThreshold);
      setPhoneThreshold(phoneReportThreshold);
      setSocialThreshold(socialReportThreshold);
      setAutoThreshold(autoReportThreshold);
    }, [peopleReportThreshold, propertyReportThreshold, phoneReportThreshold, socialReportThreshold, autoReportThreshold]);

  // Open modal and also process dispositions request
  const handleOpen = async (e) => setModalOpen(true);
  const handleClose = (e) => setModalOpen(false);

    // Update an existing membership
    const submitThresholdUpdate = async () => {
      const options = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          CustomerId: customerId,
          UserId: userId,
          ReportDownloadId: id,
          PeopleReportThreshold: newPeopleThreshold !== peopleReportThreshold ? newPeopleThreshold : null,
          PropertyReportThreshold: newPropertyThreshold !== propertyReportThreshold ? newPropertyThreshold : null,
          PhoneReportThreshold: newPhoneThreshold !== phoneReportThreshold ? newPhoneThreshold : null,
          SocialReportThreshold: newSocialThreshold !== socialReportThreshold ? newSocialThreshold : null,
          AutoReportThreshold: newAutoThreshold !== autoReportThreshold ? newAutoThreshold : null,
        }),
      };

      const res = await fetch(`/api/customer/${customerId}/update-report-downloads`, options);
      const { success } = await res.json();

      if(success) {
        setCustomerData((prevState) => ({
          userDetailsInfo: prevState.userDetailsInfo,
          userOrders: prevState.userOrders,
          userPaymentInfo: prevState.userPaymentInfo,
          userCallNotesInfo: prevState.userCallNotesInfo,
          userEmailNotesInfo: prevState.userEmailNotesInfo,
          userMembershipInfo: prevState.userMembershipInfo,
          userTrackingInfo: prevState.userTrackingInfo,
          userProgramsInfo: prevState.userProgramsInfo,
          userLoginHistoryInfo: prevState.userLoginHistoryInfo,
          dispositions: prevState.dispositions,
          userEvents: prevState.userEvents,
          userReportHistory: prevState.userReportHistory,
          userCallLog: prevState.userCallLog,
          userLockouts: prevState.userLockouts,
          userReportDownloads: {
            ...prevState.userReportDownloads,
            reportDownloads: {
              ...prevState.userReportDownloads.reportDownloads,
              peopleReportThreshold: newPeopleThreshold,
              propertyReportThreshold: newPropertyThreshold,
              phoneReportThreshold: newPhoneThreshold,
              socialReportThreshold: newSocialThreshold,
              autoReportThreshold: newAutoThreshold,
            },
          },
        }));
      }
      setUpdatedData((prevState) => ({
        ...prevState.updateData,
        updateData: {
          ...prevState.updateData,
          state: success ? true : false,
          message: success
            ? "Thresholds updated successfully"
            : "Failed to update thresholds",
        },
      }));
      setTrigger("UPDATE_CALL_NOTES");
      setModalOpen(false);
    };

  return (
    <div className="user-data-container" style={{marginBottom: "1rem"}}>
      {loading ? (
        <div className="loading-widget">
          <Loading />
        </div>
      ) : (
        <>
          <div className="customer-widget-header">
            <p
              className="customer-widget-heading"
              style={{ width: "100%", padding: ".5rem .5rem" }}
            >
              Customer Report Pulls
              </p>
            {reportDownloads && (
              <div>
                {open && (
                  <button
                    className="submit-btn-details moveRight"
                    onClick={() => handleOpen()}
                  >
                    <span style={{color: "#fff"}}>Edit Thresholds</span>
                  </button>
                )}
              </div>
            )}
              <ArrowDropDownIcon
                onClick={() => {
                  setIsOpen(!open);
                  setToggleDropdown(!toggleDropdown);
                }}
                className={`arrow-dropdown ${
                  toggleDropdown ? "arrow-open" : "arrow-close"
                }`}
              />
          </div>
          <div
            className={`${
              open ? "show-data-table-call" : "no-data-table-call"
            }`}
          >
            {reportDownloads && (
              <CustomerReportDownloadsTable
                reportDownloads={reportDownloads}
                open={open}
              />
            )}
            <EditModal open={modalIsOpen} handleClose={handleClose}>
              <>
                <div className="modal-header">
                  <h2 style={{ padding: ".5rem", color: "#6acde6" }}>Edit Thresholds</h2>
                  <CloseIcon
                    className="close-icons"
                    onClick={() => handleClose()}
                  />
                </div>
                <TextField
                  id="outlined-full-width"
                  className="input-el"
                  label={"People Report Threshold"}
                  style={{ margin: 8, width: "14rem" }}
                  fullWidth={false}
                  margin="normal"
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  value={newPeopleThreshold}
                  onChange={(e) => setPeopleThreshold(e.target.value)}
                />
                <TextField
                  id="outlined-full-width"
                  className="input-el"
                  label={"Property Report Threshold"}
                  style={{ margin: 8, width: "14rem" }}
                  fullWidth={false}
                  margin="normal"
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  value={newPropertyThreshold}
                  onChange={(e) => setPropertyThreshold(e.target.value)}
                />
                <TextField
                  id="outlined-full-width"
                  className="input-el"
                  label={"Phone Report Threshold"}
                  style={{ margin: 8, width: "14rem" }}
                  fullWidth={false}
                  margin="normal"
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  value={newPhoneThreshold}
                  onChange={(e) => setPhoneThreshold(e.target.value)}
                />
                <TextField
                  id="outlined-full-width"
                  className="input-el"
                  label={"Social Report Threshold"}
                  style={{ margin: 8, width: "14rem" }}
                  fullWidth={false}
                  margin="normal"
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  value={newSocialThreshold}
                  onChange={(e) => setSocialThreshold(e.target.value)}
                />
                <TextField
                  id="outlined-full-width"
                  className="input-el"
                  label={"Auto Report Threshold"}
                  style={{ margin: 8, width: "14rem" }}
                  fullWidth={false}
                  margin="normal"
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  value={newAutoThreshold}
                  onChange={(e) => setAutoThreshold(e.target.value)}
                />
                <button
                  className="submit-note-btn moveRight"
                  onClick={(e) => submitThresholdUpdate(e)}
                >
                  <span style={{ color: "#fff" }}>Submit</span>
                </button>
              </>
            </EditModal>
          </div>
        </>
      )}
    </div>
  );
};
export default CustomerReportDownloadsWidget;
